<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-autocomplete
          label="Cotista"
          hide-details

          multiple
          clearable
          small-chips
          deletable-chips

          :items="filterOptions.quotaholderName"
          :value="filters.quotaholderName"
          @change="(newValue) => updateFilters({ quotaholderName: newValue })"
        />
      </v-col>

      <v-col cols="12">
        <v-autocomplete
          label="Data da aplicação"
          hide-details

          multiple
          clearable
          small-chips
          deletable-chips

          :items="filterOptions.purchaseDate"
          :value="filters.purchaseDate"
          @change="(newValue) => updateFilters({ purchaseDate: newValue })"
        />
      </v-col>

      <v-col cols="12">
        <v-autocomplete
          label="Data base performance"
          hide-details

          multiple
          clearable
          small-chips
          deletable-chips

          :items="filterOptions.performanceFeeBaseDate"
          :value="filters.performanceFeeBaseDate"
          @change="(newValue) => updateFilters({ performanceFeeBaseDate: newValue })"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'LiabilitiesDetailsFilters',

  props: {
    filters: {
      type: Object,
      required: true,
    },

    filterOptions: {
      type: Object,
      required: true,
    },
  },

  watch: {
    filterOptions: {
      deep: true,
      immediate: true,
      handler(newOptions) {
        const validFilters = {};

        Object.entries(newOptions).forEach(([key, options]) => {
          validFilters[key] = this.filters[key].filter((val) => options.includes(val));
        });

        this.updateFilters(validFilters);
      },
    },
  },

  methods: {
    updateFilters(newValues) {
      this.$emit('update:filters', { ...this.filters, ...newValues });
    },
  },
};
</script>
